export default "__VITE_ASSET__BrnRCpCt__"